import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useToken } from '../../auth/useToken';
import { useQueryParams } from '../../util/useQueryParams';

export const LogInPage = () => {
  const [, setToken] = useToken();
  const [errorMessage, setErrorMessage] = useState('');
  const [emailValue, setEmailValue] = useState('');
  const [passwordValue, setPasswordValue] = useState('');
  const [googleOauthUrl, setGoogleOauthUrl] = useState('');
  const { token: oauthToken } = useQueryParams();
  const [isLoading, setIsLoading] = useState(false);
  const [isOauthLoading, setIsOauthLoading] = useState(false);
  
  const navigate = useNavigate();


  useEffect(() => {
    if (oauthToken) {
      setToken(oauthToken); 
      navigate('/');
    }
  },[oauthToken, setToken, navigate]);

  useEffect(() => {
    const loadOauthUrl = async () => {
        try {
            const response = await axios.get('/auth/google/url');
            console.log('Google OAuth URL Response:', response.data);
            const { url } = response.data;
            setGoogleOauthUrl(url);
        } catch (e) {
            console.error('Error loading Google OAuth URL:', e);
        }
    };
    loadOauthUrl();
  }, []);


  const onLogInClicked = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post('/api/login', {
        email: emailValue,
        password: passwordValue,
      });
      const { token } = response.data;
      setToken(token);
      navigate('/');
    } catch (error) {
      const message = error.response?.data?.message || 'Something went wrong during login. Please try again.';
      setErrorMessage(message);
      setPasswordValue('');
    } finally {
      setIsLoading(false);
    }
  };

  const onGoogleLoginClicked = () => {
    setIsOauthLoading(true);
    window.location.href = googleOauthUrl;
  };

  const isEmailValid = emailValue.includes('@');

  return (
    <div className="content-container">
      <h1>Log In</h1>
      {errorMessage && <div className="fail">{errorMessage}</div>}
      <input
        className={isEmailValid ? 'valid' : 'invalid'}
        value={emailValue}
        onChange={e => setEmailValue(e.target.value)}
        placeholder="someone@gmail.com"
        aria-label="Email Address"
      />
      {!isEmailValid && emailValue && <div className="fail">Please enter a valid email address.</div>}
      <input
        type="password"
        value={passwordValue}
        onChange={e => setPasswordValue(e.target.value)}
        placeholder="password"
        aria-label="Password"
      />
      <hr />
      <button
        disabled={!emailValue || !passwordValue || !isEmailValid || isLoading}
        onClick={onLogInClicked}
      >
        {isLoading ? 'Logging In...' : 'Log In'}
      </button>
      <button onClick={() => navigate('/forgot-password')}>Forgot your password?</button>
      <button onClick={() => navigate('/signup')}>Don't have an account? Sign Up</button>
      <button
        disabled={!googleOauthUrl || isOauthLoading}
        onClick={onGoogleLoginClicked}
      >
        {isOauthLoading ? 'Redirecting...' : 'Log in with Google'}
      </button>
    </div>
  );
};
